/** @typedef {{ id: string, label: string, color?: string, gradient?: string }} AccentSwatch */

/** @type {Array<{ value: string, label: string }>} */
export const APPEARANCE_MODE_OPTIONS = [
  { value: 'auto', label: 'Auto' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
]

/** @type {AccentSwatch[]} */
export const ACCENT_COLOR_SWATCHES = [
  { id: 'rainbow', label: 'Rainbow', gradient: 'conic-gradient(from 180deg, #ff6b6b, #ffd93d, #6bcb77, #4d96ff, #9b59b6, #ff6b6b)' },
  { id: 'blue', label: 'Blue', color: '#0078d4' },
  { id: 'purple', label: 'Purple', color: '#8764b8' },
  { id: 'pink', label: 'Pink', color: '#e3008c' },
  { id: 'red', label: 'Red', color: '#c50f1f' },
  { id: 'orange', label: 'Orange', color: '#d83b01' },
  { id: 'yellow', label: 'Yellow', color: '#c19c00' },
  { id: 'green', label: 'Green', color: '#107c10' },
  { id: 'grey', label: 'Grey', color: '#8a8886' },
]

/** @type {Array<{ value: string, label: string, previewColor: string }>} */
export const TEXT_HIGHLIGHT_OPTIONS = [
  { value: 'automatic', label: 'Automatic', previewColor: '#8a9ba8' },
  { value: 'blue', label: 'Blue', previewColor: '#0078d4' },
  { value: 'green', label: 'Green', previewColor: '#107c10' },
  { value: 'yellow', label: 'Yellow', previewColor: '#c19c00' },
  { value: 'pink', label: 'Pink', previewColor: '#e3008c' },
]

export const DOCK_SIZE_MARKS = [
  { value: 0, label: 'Small' },
  { value: 100, label: 'Large' },
]

export const DOCK_MAGNIFICATION_MARKS = [
  { value: 0, label: 'Off' },
  { value: 35, label: 'Small' },
  { value: 100, label: 'Large' },
]
